<template>
  <div class="parent">
    <div class="divTitle" style="padding-bottom:68px;">
      <div></div>
      <div class="divTitleDisplay" :style="{ color: titleColor }">
        <img src="../img/baseStart.png" /><span class="titleSpan">{{
          title
        }}</span
        ><slot></slot>
        <img src="../img/baseEnd.png" />
      </div>
      <div class="divDescribe" v-if="desc" :style="{ color: descColor }">
        {{ desc }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "#212121",
    },
    desc: {
      type: String,
      default: "",
    },
    descColor: {
      type: String,
      default: "#a2a2a3",
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../../web/asserts/common/scss/commonTitleWidge.scss";
</style>
